export default "__VITE_ASSET__B7X2WbBt__"